$(window).on("load", function () {
  $(".preload").addClass("complete");
});

$("document").ready(function () {
  console.log("ready");

  $(".screen").each(function (index) {
    var $this = $(this);
    var offset = $this.data("offset");
    console.log("element");
    if (typeof offset === "undefined") {
      offset = "70%";
    }

    $this.waypoint(
      function (direction) {
        if (direction == "down") {
          var currentClass = $this.attr("class");
          $this.attr("class", currentClass + " goactive");
        } else {
          $this.removeClass("goactive");
        }
      },
      {
        offset: offset,
      }
    );
  });

  $(".videothumb a").click(function (e) {
    e.preventDefault();
    var $this = $(this);
    var video = $this.data("target");
    console.log(video);
    $(".videoscreen").fadeOut();
    $("#" + video).fadeIn();
  });

  $(".pictos a").on("click", function (e) {
    e.preventDefault();
    var zone = $(this).data("target");
    $(".pop").each(function () {
      $(this).hide();
    });
    $("#pop-" + zone).fadeIn();
    console.log("clic " + zone);
  });

  $(".btn-close").on("click", function (e) {
    e.preventDefault();
    $(".pop").fadeOut();
  });

  $(".pop").click(function (e) {
    $(".pop").each(function () {
      $(this).hide();
    });
  });
});
